import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import BlogForm, { BLOG_ROUTE, Spinner, blogEditRoute, Toast, blogApi, useToast } from "./blogShared";

export default function EditBlogPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [initial, setInitial] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState("");
  const [saving, setSaving] = useState(false);
  const [serverErrors, setServerErrors] = useState(null);
  const [toast, setToast, closeToast] = useToast();

  useEffect(() => {
    let alive = true;
    setLoading(true);
    setLoadError("");
    blogApi
      .get(slug)
      .then((res) => {
        if (!alive) return;
        const b = res.data;
        setInitial({
          title: b.title || "",
          slug: b.slug || "",
          industry: b.industry_id ?? "",
          short_description: b.short_description || "",
          content: b.content || "",
          author: b.author || "",
          is_published: Boolean(b.is_published),
          featured_image: b.featured_image || "",
          seo: b.seo,
          schema: b.schema,
          og_image: b.og_image || b.seo?.og_image || "",
          twitter_image: b.twitter_image || b.seo?.twitter_image || "",
        });
      })
      .catch((err) => alive && setLoadError(err.message || "Blog not found."))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [slug]);

  const handleSubmit = async (fd, form) => {
    setSaving(true);
    setServerErrors(null);
    try {
      await blogApi.update(slug, fd);
      setToast({ type: "success", message: "Changes saved" });
      // slug changed → move to the new URL
      //   if (form.slug.trim() !== slug) navigate(`${BLOG_ROUTE}/${form.slug.trim()}`, { replace: true });
      if (form.slug.trim() !== slug) navigate(blogEditRoute(form.slug.trim()), { replace: true });
    } catch (err) {
      setServerErrors(err.fields);
      setToast({ type: "error", message: err.message });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 sm:p-8">
      <Toast toast={toast} onClose={closeToast} />
      <div className="mx-auto max-w-4xl">
        <Link to={BLOG_ROUTE} className="text-sm text-gray-500 hover:text-gray-900">
          ← Back to blogs
        </Link>
        <h1 className="mb-6 mt-2 text-2xl font-semibold text-gray-900">Edit blog</h1>

        {loading ? (
          <div className="flex items-center gap-3 py-16 text-gray-500">
            <Spinner /> Loading blog…
          </div>
        ) : loadError ? (
          <p className="py-16 text-sm text-red-600">{loadError}</p>
        ) : (
          <BlogForm
            key={slug}
            isEdit
            initial={initial}
            saving={saving}
            serverErrors={serverErrors}
            submitLabel="Save changes"
            onSubmit={handleSubmit}
            onCancel={() => navigate(BLOG_ROUTE)}
          />
        )}
      </div>
    </div>
  );
}